// Centralized feature flags for temporary gates that flip per environment.
// Flip the right-hand side (or the IS_PROD predicate) to re-enable a flow.

const IS_PROD = import.meta.env.PROD;

// Disabled in production until allowed-domain restrictions are configured.
export const GOOGLE_OAUTH_ENABLED = !IS_PROD;
